import React, { useEffect } from "react";
import CertificateCard from "components/widget/CertificateCard";
import { connect } from "react-redux";
import HeaderComponent from "components/card/HeaderComponent";
import { LucideAward } from "lucide-react";
import {
	getTrainingClassCertificationList
} from "../../../../redux/trainingclasscertification/trainingClassCertificationState";


const TrainingCertificationTable = ({
	recordList, 
	pagination, 
	doSearch, 
}) => {

useEffect(() => {
	doSearch({ paginate: pagination?.per_page});
}, [doSearch, pagination?.per_page]);

	return (
		<HeaderComponent
			title="My Certifications"
			description="View your earned certifications and badges"
			labelIcon={<LucideAward size={20}/>}
		>

			<div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-2 2xl:grid-cols-2 3xl:grid-cols-4" >
				{recordList.length > 0 ? (
					recordList.map((certification) => (
						<CertificateCard
							key={certification.tcc_id}
							recordData={certification}
						/>
					))
				) : (
					<p className="text-gray-500 text-center col-span-full">
						No available certifications found.
					</p>
				)}
			</div>
				

		</HeaderComponent>
  	);
};

const mapStateToProps = (state) => ({
	recordList: state.trainingClassCertification.trainingClassCertificationList?.items,
	pagination: state.trainingClassCertification.trainingClassCertificationList?.pagination,
	filters: state.trainingClassCertification.trainingClassCertificationList?.filters,
	requesting: state.trainingClassCertification.trainingClassCertificationList?.requesting,
	error: state.trainingClassCertification.trainingClassCertificationList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getTrainingClassCertificationList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingCertificationTable);
